<template>
    <LoadingStruct :is-loading="loadingInfos">
        <div
            class="uk-padding-large clickandbuy-struct uk-height-viewport"
            :style="'background-color: ' + getColor">
            <div class="site-struct medium">
                <div class="uk-grid uk-grid-match uk-height-viewport" uk-grid>
                    <div class="uk-width-1-3@m uk-width-1-1">
                        <div class="logo-struct">
                            <img
                                :src="apiUrl + '/logos/' + getInfos.logo"
                                class="clickandbuy-logo" />

                            <div class="clickandbuy-name">
                                {{ getInfos.name }}
                            </div>

                            <div
                                v-if="getInfos.clickAndBuy.title"
                                class="clickandbuy-title">
                                {{ getInfos.clickAndBuy.title }}
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-2-3@m uk-width-1-1">
                        <div v-if="selected">
                            <Card mode="default" is-dark is-round>
                                <Button
                                    is-round
                                    mode="default"
                                    is-max
                                    has-action
                                    :action="actionResetSelect">
                                    <Translate translation-key="back" />
                                </Button>

                                <hr />

                                <div class="uk-text-center">
                                    <img
                                        v-if="selected.mediaFileId"
                                        :src="
                                            apiUrl +
                                            '/clickandbuys/' +
                                            selected.id +
                                            '/media/' +
                                            selected.mediaFileId
                                        "
                                        class="clickandbuy-media" />
                                </div>

                                <div class="clickandbuy-price uk-badge badge">
                                    {{ getPrice(selected) }}
                                </div>

                                <div class="clickandbuy-title">
                                    {{ selected.title }}
                                </div>

                                <div
                                    v-if="selected.text"
                                    class="clickandbuy-text"
                                    v-html="selected.text" />

                                <hr />

                                <div class="uk-margin-medium-bottom" />
                                <div class="section-title">
                                    {{ $t('address') }}
                                </div>
                                <div class="uk-grid-small" uk-grid>
                                    <div
                                        v-for="(
                                            inputField, key
                                        ) in contactFields"
                                        :class="inputField.width"
                                        :key="'i' + inputField.name">
                                        <TextField
                                            is-round
                                            v-model="inputField.value"
                                            :autocomplete="
                                                inputField.autocomplete
                                            "
                                            :autofocus="inputField.autofocus"
                                            :field-key="key"
                                            :hasPasswordMeter="
                                                inputField.hasPasswordMeter
                                            "
                                            :icon="inputField.icon"
                                            :is-optional="inputField.optional"
                                            :label="inputField.label"
                                            :name="inputField.name"
                                            :rules="inputField.rules"
                                            :type="inputField.type"
                                            :validate="triggerContactFields"
                                            @setValid="setValidContactFields"
                                            :has-keyboard="isTerminalMode" />
                                        <div
                                            v-if="
                                                key < contactFields.length - 1
                                            "
                                            class="uk-margin-small-bottom" />
                                    </div>
                                </div>

                                <div class="uk-margin-small-bottom" />
                                <LabelWithError :label="$t('country') + '*'" />
                                <form autocomplete="off">
                                    <select
                                        v-model="country"
                                        name="country"
                                        :disabled="
                                            getInfos.shippingCountries
                                                .length === 1
                                        "
                                        class="uk-select uk-input-styled round">
                                        <option
                                            v-for="option in getInfos.shippingCountries"
                                            :key="option"
                                            :value="option">
                                            {{ $t(option) }}
                                        </option>
                                    </select>
                                </form>

                                <div class="uk-margin-medium-bottom" />
                                <TextArea
                                    v-model="comments"
                                    is-round
                                    is-label-large
                                    label="comments"
                                    name="comments"
                                    rules="max:4096" />

                                <div v-if="selected && selected.price > 0.0">
                                    <div class="uk-margin-medium-bottom" />
                                    <div
                                        class="uk-grid-small uk-margin-small-medium-top total-costs-text"
                                        uk-grid>
                                        <div class="uk-width-expand" uk-leader>
                                            {{ $t('total') }}
                                        </div>
                                        <div>{{ getPrice(selected) }}</div>
                                    </div>
                                    <div class="vat">
                                        {{
                                            $t('vat.message', {
                                                vat: getInfos.vat,
                                            })
                                        }}
                                    </div>

                                    <div class="uk-margin-medium-bottom" />
                                    <div
                                        class="section-title"
                                        id="payment-method">
                                        {{ $t('payment.method') }}
                                    </div>

                                    <stripe-element-payment
                                        v-if="elementsOptions.clientSecret"
                                        @element-ready="setPaymentRendered"
                                        @element-change="onElementChange"
                                        ref="paymentRef"
                                        :pk="getInfos.stripe.key"
                                        :elements-options="elementsOptions"
                                        :confirm-params="confirmParams" />
                                </div>

                                <div class="uk-margin-medium-bottom" />
                                <div class="section-title">
                                    {{
                                        $t('termsAndCondition.and.dataPrivacy')
                                    }}
                                </div>
                                <Checkbox
                                    is-round
                                    v-model="confirmTerms"
                                    :validate="triggerTerms"
                                    label="termsAndConditions.confirm"
                                    name="terms"
                                    rules="required"
                                    @setValid="setTermsValid" />

                                <div class="uk-margin-medium-bottom" />
                                <Button
                                    is-round
                                    :action="actionOrder"
                                    :is-loading="orderLoading"
                                    :text="$t('paid.buy')"
                                    has-action
                                    is-large
                                    is-max
                                    mode="success" />
                                <div
                                    v-if="orderError"
                                    class="uk-margin-medium-bottom" />
                                <ErrorMessage
                                    :custom-errors="[
                                        {
                                            code: 408,
                                            message: $t('session.timed.out'),
                                        },
                                    ]"
                                    :error="orderError" />
                            </Card>
                        </div>
                        <div
                            v-else
                            class="uk-grid uk-child-width-1-2@s uk-child-width-1-1"
                            uk-grid="masonry:true">
                            <div
                                v-for="clickAndBuy in getInfos.clickAndBuys"
                                :key="clickAndBuy.id">
                                <ClickAndBuyElement
                                    @selected="handleSelected"
                                    :click-and-buy="clickAndBuy" />
                            </div>
                        </div>

                        <div class="footer">
                            <div
                                class="uk-animation-fade uk-margin-medium-top uk-margin-medium-right uk-margin-medium-bottom">
                                <div
                                    uk-grid
                                    class="uk-grid-small uk-child-width-auto uk-flex-center uk-flex-middle">
                                    <div v-if="getInfos.footerText">
                                        {{ getInfos.footerText }}
                                    </div>

                                    <div>
                                        <ToggleItem
                                            is-dark
                                            toggle="target: #termsAndConditions">
                                            {{ $t('termsAndConditions') }}
                                        </ToggleItem>
                                        <Modal
                                            id="termsAndConditions"
                                            :title="$t('termsAndConditions')"
                                            is-extended>
                                            <div
                                                v-html="
                                                    getInfos.termsAndConditions
                                                " />
                                        </Modal>
                                    </div>
                                    <div>
                                        <ToggleItem
                                            is-dark
                                            toggle="target: #dataPrivacy">
                                            {{ $t('dataPrivacy') }}
                                        </ToggleItem>
                                        <Modal
                                            id="dataPrivacy"
                                            :title="$t('dataPrivacy')"
                                            is-extended>
                                            <div
                                                v-html="getInfos.dataPrivacy" />
                                        </Modal>
                                    </div>
                                    <div>
                                        <ToggleItem
                                            is-dark
                                            toggle="target: #siteNotice">
                                            {{ $t('siteNotice') }}
                                        </ToggleItem>
                                        <Modal
                                            id="siteNotice"
                                            :title="$t('siteNotice')"
                                            is-extended>
                                            <div v-html="getInfos.siteNotice" />
                                        </Modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </LoadingStruct>
</template>

<script>
import ClickAndBuyElement from '@/views/clickandbuy/ClickAndBuyElement.vue';
import Modal from '@/components/generic/Modal.vue';
import ToggleItem from '@/components/generic/ToggleItem.vue';
import Button from '@/components/generic/Button.vue';
import Translate from '@/components/Translate.vue';
import Card from '@/components/generic/Card.vue';
import TextArea from '@/components/TextArea.vue';
import TextField from '@/components/generic/TextField.vue';
import LabelWithError from '@/components/generic/LabelWithError.vue';
import Checkbox from '@/components/generic/Checkbox.vue';
import axios from 'axios';
import LoadingStruct from '@/views/LoadingStruct.vue';
import {StripeElementPayment} from '@vue-stripe/vue-stripe';
import ErrorMessage from '@/components/generic/ErrorMessage.vue';
import {parse as uuidParse} from "uuid";

export default {
    name: 'ClickAndBuys',
    components: {
        ErrorMessage,
        StripeElementPayment,
        LoadingStruct,
        Checkbox,
        LabelWithError,
        TextField,
        TextArea,
        Card,
        Translate,
        Button,
        ToggleItem,
        Modal,
        ClickAndBuyElement,
    },
    computed: {
        getColor() {
            if (
                this.getInfos &&
                this.getInfos.clickAndBuy &&
                this.getInfos.clickAndBuy.color
            ) {
                return this.getInfos.clickAndBuy.color;
            }

            return '';
        },
    },
    data() {
        return {
            selected: null,

            triggerContactFields: 0,
            contactFields: [
                {
                    value: '',
                    valid: false,

                    name: 'name',
                    label: 'name',
                    icon: 'user',
                    rules: 'required|max:320',
                    width: 'uk-width-1-2@m uk-width-1-1',
                },
                {
                    value: '',
                    valid: false,

                    name: 'email',
                    label: 'emailAddress',
                    icon: 'mail',
                    rules: 'required|emailV2',
                    width: 'uk-width-1-2@m uk-width-1-1',
                },

                {
                    value: '',
                    valid: false,

                    name: 'street',
                    label: 'street',
                    icon: 'home',
                    rules: 'required|max:320',
                    width: 'uk-width-1-1',
                },
                {
                    value: '',
                    valid: false,

                    name: 'zip',
                    label: 'zip',
                    icon: 'location',
                    rules: 'required|numeric|max:320',
                    width: 'uk-width-1-2@m uk-width-1-1',
                },
                {
                    value: '',
                    valid: false,

                    name: 'city',
                    label: 'city',
                    icon: 'world',
                    rules: 'required|max:320',
                    width: 'uk-width-1-2@m uk-width-1-1',
                },
            ],

            country: '',

            comments: '',

            confirmTerms: false,
            triggerTerms: 0,

            loadingInfos: true,

            requestId: null,

            paymentRendered: false,
            paymentCompleted: false,
            elementsOptions: {
                clientSecret: null,
                appearance: {
                    variables: {
                        colorPrimary: '#092633',
                        colorBackground: '#ffffff',
                        colorText: '#30313d',
                        colorDanger: '#df1b41',
                        borderRadius: '5px',
                    },
                },
            },
            confirmParams: {
                return_url:
                    window.location.href + 'orders/' + this.requestToken + '/',
            },

            orderLoading: false,
            orderError: null,
            orderSuccess: false,
        };
    },
    methods: {
        onElementChange(event) {
            this.paymentCompleted = event.complete;
        },
        actionOrder() {
            this.triggerTerms++;
            this.triggerContactFields++;

            if (!this.termsValid) {
                return;
            }

            for (let i = 0, j = this.contactFields.length; i < j; i++) {
                if (!this.contactFields[i].valid) {
                    return;
                }
            }

            const isPaid = this.selected.price > 0.0;

            if (isPaid && !this.paymentCompleted) {
                this.$refs.paymentRef.focus();
                return;
            }

            let platform = 'browser';
            if (this.isApp) {
                platform = 'app';
            }

            this.orderLoading = true;

            let http = axios.create();
            http.post(
                this.apiUrl + '/clickandbuys/' + this.selected.id + '/orders',
                {
                    requestId: this.requestId,

                    name: this.contactFields[0].value,
                    email: this.contactFields[1].value,
                    comments: this.comments,
                    language: this.$i18n.locale,
                    platform: platform,

                    street: this.contactFields[2].value,
                    zip: this.contactFields[3].value,
                    city: this.contactFields[4].value,
                    country: this.country,
                }
            )
                .then(async () => {
                    const self = this;
                    if (isPaid) {
                        try {
                            const result =
                                await this.$refs.paymentRef.stripe.confirmPayment(
                                    {
                                        elements:
                                            this.$refs.paymentRef.elements,
                                        confirmParams: {
                                            return_url:
                                                window.location.href.endsWith(
                                                    '/'
                                                )
                                                    ? window.location.href +
                                                      'orders/' +
                                                      this.requestToken +
                                                      '/'
                                                    : window.location.href +
                                                      '/orders/' +
                                                      this.requestToken +
                                                      '/',
                                        },
                                    }
                                );

                            if (result.error) {
                                self.orderLoading = false;
                                this.$refs.paymentRef.focus();
                            } else {
                                self.orderLoading = false;
                                self.orderError = null;
                            }
                        } catch (e) {
                            self.orderLoading = false;
                            this.$refs.paymentRef.focus();
                        }
                    } else {
                        this.orderError = null;
                        this.orderSuccess = true;
                        this.orderLoading = false;
                    }
                })
                .catch((err) => {
                    this.orderError = err;
                    this.orderLoading = false;
                });
        },
        postOrderRequestPayment() {
            let http = axios.create();
            http.post(
                this.apiUrl + '/clickandbuys/' + this.selected.id + '/payment',
                {
                    requestId: this.requestId,
                }
            )
                .then((response) => {
                    this.requestId = response.data.id;
                    this.elementsOptions.clientSecret = response.data.key;
                    this.$refs.paymentRef.update();
                })
                .catch(() => {});
        },
        setPaymentRendered() {
            this.paymentRendered = true;
        },
        receiveInfosLocale() {
            this.loadingInfos = true;

            let http = axios.create();
            http.get(this.apiUrl + '/infos')
                .then((response) => {
                    let data = response.data;

                    if (!data.clickAndBuy) {
                        this.routeTo('');
                        return;
                    }

                    this.$store.state.infos = data;

                    this.country = data.shippingCountries[0];
                    if (data.shippingCountries.includes(data.country)) {
                        this.country = data.country;
                    }

                    const clickAndBuyID = this.$route.params.clickandbuy;

                    try {
                        uuidParse(clickAndBuyID);
                        console.log(clickAndBuyID)
                        const target= this.getByID(data.clickAndBuys, clickAndBuyID)
                        console.log(target)
                        if(target) {
                            this.handleSelected(target)
                        } else {
                            this.routeTo('clickandbuys')
                        }

                    } catch (e) {
                        this.routeTo('clickandbuys')
                    }

                    this.loadingInfos = false;
                })
                .catch((e) => {
                    this.checkGenericError(e);
                    this.loadingInfos = false;
                });
        },
        setValidContactFields(valid, fieldKey) {
            this.contactFields[fieldKey].valid = valid;
        },
        setTermsValid(valid) {
            this.termsValid = valid;
        },
        actionResetSelect() {
            this.selected = null;
            this.requestId = null;
        },
        getPrice(clickAndBuy) {
            if (clickAndBuy.price === 0.0) {
                return this.$t('free');
            }

            return this.getNumberWithCurrency(clickAndBuy.price);
        },


        getByID(clickandbuys, id) {
            for(let i=0, j= clickandbuys.length; i<j; i++) {
                const clickandbuy = clickandbuys[i];

                if(clickandbuy.id === id){
                    return clickandbuy
                }

            }

            return undefined;
        }
    },
    created() {
        this.receiveInfosLocale();
    },
};
</script>

<style lang="scss" scoped>
.clickandbuy-logo {
    max-width: 180px;
    max-height: 180px;
    border-radius: 5px;
}

.vat {
    font-size: 14px;
    margin-top: 15px;
}

.clickandbuy-name {
    font-size: 24px;
    margin-top: 20px;
    font-weight: 500;
    color: $site-background;
}

.clickandbuy-title {
    margin-top: 15px;
    color: $site-background;
}

.clickandbuy-struct {
    padding-top: 60px;
    color: $site-background;
}

.logo-struct {
    position: fixed;
}

.footer {
    color: $site-background;
}

.clickandbuy-media {
    border-radius: 5px;
    max-height: 200px;
}

.clickandbuy-title {
    font-size: 18px;
    font-weight: 500;
    margin-top: 20px;
}

.clickandbuy-text {
    word-break: break-word;
    margin-top: 15px;
}

.clickandbuy-price {
    margin-top: 20px;
}

.badge {
    font-size: 16px !important;
    padding: 12px 15px !important;
    background-color: $info-color !important;
}

.section-title {
    font-size: 18px;
    font-weight: 500;
    color: $site-background;
    margin-bottom: 10px;
}

.round {
    border-radius: 5px;
}
</style>
